export const runtimeConfig = {
  apiUrl: '@@__VITE_API_URL__@@',
  reownAppId: '@@__VITE_REOWN_APP_ID__@@',
  muiLicenseKey: '@@__VITE_MUI_LICENSE_KEY__@@',
  sentryDsn: '@@__VITE_SENTRY_DSN__@@',
  sentryEnvironment: '@@__VITE_SENTRY_ENVIRONMENT__@@',
  posthogKey: '@@__VITE_POSTHOG_KEY__@@',
  posthogHost: '@@__VITE_POSTHOG_HOST__@@',
  xTwitterClientKey: '@@__VITE_TWITTER_CLIENT_ID__@@',
  funBridgeApiKey: '@@__VITE_FUNBRIDGE_API_KEY__@@',
  analyticsSalt: '@@__VITE_ANALYTICS_SALT__@@',
  statusPageUrl: '@@__VITE_STATUS_PAGE_URL__@@',
};
